module.exports = __webpack_public_path__ + "img/Apollodorus_Damascus_Glyptotek.7f29f10d.png";